import React from "react";
import {autobind} from "core-decorators";
import {action, observable} from "mobx";
import {inject, observer} from "mobx-react";
import {Button, Modal, Tooltip} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import {FaFileImport} from "react-icons/fa";

import "./CatalogActions.scss";
import {CatalogQuery} from "@/graphql/types";
import {addPieceFromCatalog} from "@/lib/backend";
import {paths} from "@/routes";
import Store from "@/stores";

export interface ICatalogActionsProps {
  piece: CatalogQuery["pieces"][0];
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class CatalogActions extends React.Component<ICatalogActionsProps> {
  @observable loading: boolean = false;

  async addPiece() {
    this.setLoading(true);
    const {piece, store} = this.props;
    try {
      const {pieceId} = await addPieceFromCatalog({ensembleId: store!.session.selectedEnsemble!.id, pieceId: piece.id});
      if (pieceId === undefined) throw new Error("No pieceId was returned");
      store!.history.history.push(paths.piece(pieceId)); // show added piece
    } catch (error) {
      console.error(error);
      Modal.error({title: "Something went wrong", content: error?.data?.message || "Unknown error"});
    }
    this.setLoading(false);
  }

  @action
  setLoading(loading: boolean) {
    this.loading = loading;
  }

  public render() {
    const {piece} = this.props;
    const pieceAlreadyAdded = piece.catalog_pieces.length > 0;
    return (
      <div className="CatalogActions">
        <Tooltip
          placement="topLeft"
          arrowPointAtCenter
          title={pieceAlreadyAdded ? "Piece already added" : "Add to your repertoire"}
        >
          <Button
            type="link"
            shape="circle"
            size="small"
            disabled={pieceAlreadyAdded || this.loading}
            onClick={this.addPiece}
          >
            {this.loading ? <LoadingOutlined /> : <FaFileImport />}
          </Button>
        </Tooltip>
      </div>
    );
  }
}
